import PlanFrame from './PlanFrame';

export default PlanFrame;